import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "d0e79a0c-3276-4d87-894f-f015db368fc9", content: "Source directivity", options: {} },
  { id: "ccd33d73-8a3d-4f27-9df4-4c54324aa6c0", content: "Air attenuation", options: {} },
  { id: "94d11f08-1fa5-4225-be82-fd3d564c9905", content: "Reflection of the wall", options: {} },
  {
    id: "ee304ce3-05e6-416c-b3b0-5cbf045a0e3d",
    content: "Time delay + distance decrease",
    options: {},
  },
  { id: "a6dae6ce-a2d9-446b-b3b6-fd4918d23f25", content: "Receiver directivity", options: {} },
];

const groups = [
  { id: "9d84f145-ea72-49e8-8092-d524af1bf8c2", content: "A", options: {} },
  { id: "06236541-dfd4-4f09-87ad-73a93957c6a0", content: "B", options: {} },
  { id: "a5bd1db6-79db-466c-8983-69d8e3c39900", content: "C", options: {} },
  { id: "6988d0df-d986-4b50-91f9-a80373b86d5c", content: "D", options: {} },
  { id: "ef996d3a-cf1a-45c1-bc5e-c299e0104ceb", content: "E", options: {} },
];

export const task: Task = {
  id: "d421d39a-1c53-407f-81ea-829765b09479",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "9d84f145-ea72-49e8-8092-d524af1bf8c2",
      itemsId: ["ee304ce3-05e6-416c-b3b0-5cbf045a0e3d"],
    },
    {
      groupId: "06236541-dfd4-4f09-87ad-73a93957c6a0",
      itemsId: ["ccd33d73-8a3d-4f27-9df4-4c54324aa6c0"],
    },
    {
      groupId: "a5bd1db6-79db-466c-8983-69d8e3c39900",
      itemsId: ["d0e79a0c-3276-4d87-894f-f015db368fc9"],
    },
    {
      groupId: "6988d0df-d986-4b50-91f9-a80373b86d5c",
      itemsId: ["a6dae6ce-a2d9-446b-b3b6-fd4918d23f25"],
    },
    {
      groupId: "ef996d3a-cf1a-45c1-bc5e-c299e0104ceb",
      itemsId: ["94d11f08-1fa5-4225-be82-fd3d564c9905"],
    },
  ],
};
